import { Component, ChangeDetectorRef, OnInit, ViewChild, ElementRef } from '@angular/core';
import { AuthenticationService, TestData, CandidateInformation } from '../services/authentication.service';
import { Router } from '@angular/router';
import { NgForm, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MediaMatcher } from '@angular/cdk/layout';
import { TestTakerService } from '../services/test_taker.service';
import { HttpClient } from '@angular/common/http';
import { report, ReportService } from '../services/report.service';
import * as xlsx from 'xlsx';
import { ExcelService } from '../services/excel.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-upload-question-bank',
  templateUrl: './upload-question-bank.component.html',
  styleUrls: ['./upload-question-bank.component.scss']
})
export class UploadQuestionBankComponent implements OnInit {
  report_details: report = { College_Id: '', Year_Id: '', Question_Set: '' };
  @ViewChild('myInput')
  myInputVariable: ElementRef;
  result: string[];
  userAdmin: boolean;
  userSuperAdmin: boolean;
  userTestScheduler: boolean;
  userEvaluator: boolean;
  userTestTaker: boolean;
  display: boolean;
  overall: boolean;
  questionset: boolean;
  scheduletest: boolean;
  evaluate: boolean;
  mobileQuery: MediaQueryList;
  private _mobileQueryListener: () => void;
  links = ['Super Admin', 'Admin', 'Test Scheduler', 'Test Taker'];
  email;
  user;
  fname;
  lname;
  columns: string[];
  test: TestData = {
    id: '',
    FirstName: '',
    LastName: '',
    Email: '',
    Phone: '',
    Type: ''
  };
  submitted = false;
  registerForm: FormGroup;
  isCustomStyleApplied: boolean = false;
  screenWidth: number | undefined;
  screenHeight: number | undefined;


  info;
  file;
  name;
  uploadedFiles: Array<File>;
  
  constructor(private auth: AuthenticationService, private router: Router, private formBuilder: FormBuilder, private http: HttpClient,
    private testtakerservice: TestTakerService, changeDetectorRef: ChangeDetectorRef, media: MediaMatcher, private reportservice: ReportService,private excelService:ExcelService) {
    //this.simpletest();
    this.mobileQuery = media.matchMedia('(max-width: 600px)');
    this._mobileQueryListener = () => changeDetectorRef.detectChanges();
    this.mobileQuery.addListener(this._mobileQueryListener);
  }

  ngOnInit(): void {
    this.getAccess()
    this.getScreenSize();
    this.applyStylesBasedOnResolution();
    this.registerForm = this.formBuilder.group({

      data: ['', Validators.required]
    });
  }

  get f() {
    return this.registerForm.controls;
  }

  getAccess(){
    this.user = sessionStorage.getItem('user');
    this.fname = sessionStorage.getItem('fname');

    this.lname = sessionStorage.getItem('lname');


    if (this.user === '1') {
      this.userAdmin = true;
      this.userTestScheduler = false;
      this.userEvaluator = false;
    } else if (this.user === '2') {
      this.userEvaluator = true;
      this.userAdmin = false;
      this.userTestScheduler = false;
    } else if (this.user === '3') {
      this.userTestScheduler = true;
      this.userAdmin = false;
      this.userEvaluator = false;  
    }
  }

  getScreenSize(): void {
    this.screenWidth = window.innerWidth;
    
    this.screenHeight = window.innerHeight;
    
  }

  applyStylesBasedOnResolution(): void {
    if (this.screenWidth && this.screenHeight) {
      
      if (this.screenWidth < 1366 && this.screenHeight <  641) {
        this.isCustomStyleApplied = true;
       
      
      }
     
    }
  }

  fileChange(element) {
    this.uploadedFiles = element.target.files;



    this.file = this.uploadedFiles[0].name;
  }

  Selectfile(event) {
    if (event.target.files.length > 0) {
      const file = event.target.files[0];
      this.name = file;
    }
  }
  reset() {

    this.myInputVariable.nativeElement.value = "";

  }

  upload() {
    this.submitted = true;
    //
    // let info = this.information;
    // let formData = new FormData();
    //

    var formData: any = new FormData();
    formData.append('file', this.name);
    // alert("Questions uploaded successfully")

    this.http.post('/users/upload/question_bank', formData)
      .subscribe(
        response => {
          const res = (typeof response === 'string') ? JSON.parse(response) : response;
          //

          if (res.code == 200) {
            
            Swal.fire({
              title: 'Success',
              text: 'Questions Uploaded Successfully',
              icon: 'success',
              showCancelButton: false,
              confirmButtonText: 'OK'
            }).then((result) => {
              if (result.isConfirmed) {
                this.reset()
              }
            })
          }
          else {
            Swal.fire({
              title: 'Alert',
              text: 'Upload failed',
              icon: 'warning',
              showCancelButton: false,
              confirmButtonText: 'OK'
            }).then((result) => {
              if (result.isConfirmed) {
                this.reset()
                this.exportAsXLSX()
              }
            })
          }
        },

        (error) => console.error(error));
    // alert("Upload failed")


  }

//   download_temp_validate_questions_upload() {
//     // this.data=true;
//     alert("Inside downtemp")
//     this.reportservice.download_questions_upload(this.report_details).subscribe(
//       (data) => {
//
//
//         // var csv = '';
//         // data.results.forEach((row) => {
//         //
//         //
//         //   var array = Object.values(row);
//         //
//         //   csv += array.join(',');
//         //   csv += "\n";
//         // });

//         //
//         // var hiddenElement = document.createElement('a');
//         // hiddenElement.href = 'data:application/vnd.ms-excel;charset=UTF-8,base64' + encodeURI(csv);
//         // hiddenElement.target = '_blank';
//         // hiddenElement.download = 'question_upload_error.csv';
//         // hiddenElement.click();


//         // this.dataSource = new MatTableDataSource(this.reportdetails);
//         // this.dataSource.sort=this.sort;
//         // setTimeout(() => this.dataSource.paginator = this.paginator);
//         //

//       },
//   err => {
//   console.error(err);
// }
//     );
//   }
  exportAsXLSX():void {
    this.reportservice.download_questions_upload(this.report_details).subscribe(
      (data) => {
        //
        //
        this.excelService.exportAsExcelFile(data.results, 'question_upload_error');
        // var csv = '';
        // data.results.forEach((row) => {
        //
        //
        //   var array = Object.values(row);
        //
        //   csv += array.join(',');
        //   csv += "\n";
        // });

        //
        // var hiddenElement = document.createElement('a');
        // hiddenElement.href = 'data:application/vnd.ms-excel;charset=UTF-8,base64' + encodeURI(csv);
        // hiddenElement.target = '_blank';
        // hiddenElement.download = 'question_upload_error.csv';
        // hiddenElement.click();


        // this.dataSource = new MatTableDataSource(this.reportdetails);
        // this.dataSource.sort=this.sort;
        // setTimeout(() => this.dataSource.paginator = this.paginator);
        //

      },
  err => {
  console.error(err);
}
    );

  }

}




